import React from 'react';
import { SortDownIcon, SortUpIcon, Button, ButtonMode } from 'edenred-ui';

import {
  SortIndicatorProps,
  SortingButtonProps
} from '@epi-models/components/SortingButtonComponent';

function SortIndicator({ descending }: SortIndicatorProps) {
  return descending ? <SortDownIcon /> : <SortUpIcon />;
}

export function SortingButton({
  text = '',
  sortBy,
  sortedBy,
  sortDirection,
  onSortingChange,
  ...otherProps
}: SortingButtonProps) {
  return (
    <Button
      mode={ButtonMode.None}
      onClick={() => {
        onSortingChange(sortBy, !sortDirection);
      }}
      id={`${sortBy}-sorting-button`}
      {...otherProps}
    >
      {text}
      {sortBy === sortedBy ? (
        <SortIndicator descending={sortDirection} />
      ) : null}
    </Button>
  );
}
